module.exports = "uniform vec2 resolution;\nuniform sampler2D mtexture;\n\nvoid main()\n{\n\tvec2 uv = gl_FragCoord.xy / resolution.xy;\n\tgl_FragColor = texture2D(mtexture, uv);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/passThrough.ps
// module id = 6
// module chunks = 0